// extracted by mini-css-extract-plugin
export default {"texterror":"UploadMaterialModal_texterror__DelRY","uploadSuccess":"UploadMaterialModal_uploadSuccess__oHltr"};